import React from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';

//Estilos
import './ChangePassword.css';
import './ChangePasswordMediaQueries.css';

function RequestPassword({ functions, states }) {
    const {
        register,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
        onSubmitUser,
        onSubmitPassword,
    } = functions;

    const { emailSent } = states;

    const RequestPassword = (
        <div className="form-background" onSubmit={handleSubmit(onSubmitUser)}>
            <form className="form-confirm_password">
                <h3>
                    {!emailSent
                        ? 'Olvidó su clave'
                        : 'Correo enviado exitosamente. Revisa tu casilla para continuar'}
                </h3>
                {!emailSent && (
                    <p>
                        Para reiniciar su clave usted nos debe proporcionar su
                        nombre de usuario. De esa forma enviaremos un correo
                        electrónico a su cuenta con un enlace web que le
                        permitirá introducir una nueva clave
                    </p>
                )}
                {!emailSent && (
                    <>
                        <label className="label-confirm_password">
                            <span>Usuario: </span>
                            <input
                                className="request_password-input"
                                type="text"
                                {...register('usuario', {
                                    required:
                                        'Debe ingresar su nombre de usuario',
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 20) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.usuario && (
                                <small className="form__error">
                                    {errors.usuario?.message}
                                </small>
                            )}
                        </label>
                        <div className="confirm_password-footer">
                            <button className="btn btn-primary" type="submit">
                                Enviar
                            </button>
                            <Link to={RoutesApp.Login}>
                                <button className="btn btn-secondary">
                                    Cancelar
                                </button>
                            </Link>
                        </div>
                    </>
                )}
            </form>
        </div>
    );

    return RequestPassword;
}

export default RequestPassword;
